export class InvitationRequestDTO {
  public firstName: string;

  public lastName: string;

  public email: string;
}
